import HundredBricksAPIError from '../HundredBricksAPIError';
class AuthenticationPingError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('AuthenticationPingError', ...args);
    }
}
export default AuthenticationPingError;
